import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateBase1001Component } from '../../base-1001-certificate';

@Component({
  selector:
    'authority-labs-certificate-air-conditioning-and-ventilation-systems',
  templateUrl:
    './certificate-air-conditioning-and-ventilation-systems.component.html',
  styleUrls: [
    './certificate-air-conditioning-and-ventilation-systems.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateAirConditioningAndVentilationSystemsComponent extends CertificateBase1001Component {
  systemDescription = `בדיקת התאמה למערכות מיזוג אוויר ואוורור`;
}
